import OriginalLayout from './Layout.svelte';
import OriginalHeader from './Header.svelte';
import Extra from './HeaderExtra.svelte';
import Sidebar from './Sidebar.svelte';
import OriginalContent from './Content.svelte';
import Body from './Body.svelte';
import OriginalFooter from './Footer.svelte';
import FooterExtra from './FooterExtra.svelte';
const Layout = OriginalLayout;
Layout.Header = OriginalHeader;
Layout.Header.Extra = Extra;
Layout.Content = OriginalContent;
Layout.Content.Body = Body;
Layout.Content.Sidebar = Sidebar;
Layout.Footer = OriginalFooter;
Layout.Footer.Extra = FooterExtra;
export default Layout;
